export default __webpack_public_path__ + "static/media/login.e4e7fe7a.gif";